import { useState, useEffect, useCallback } from 'react';

import getSuggestions from '@services/searchSuggestions/getSuggestions';
import addSuggestions from '@services/searchSuggestions/addSuggestions';

function useSearchSuggestions(userId, shopId) {
  const [data, setData] = useState([]);

  useEffect(() => {
    async function update() {
      const userSuggestions = (await getSuggestions(userId)) || {};
      const shopSuggestions = userSuggestions[shopId] || [];
      setData(shopSuggestions);
    }
    update();
  }, [userId, shopId]);

  const add = useCallback(
    async value => {
      await addSuggestions(userId, shopId, value);
    },
    [shopId, userId],
  );

  return { data, add };
}

export default useSearchSuggestions;
